import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import habilidades from './modules/habilidades'
import expertises from './modules/expertises'
import permissoes from './modules/permissoes'
import usuario from './modules/usuario'
import usuarioSkills from './modules/usuarioSkills'
import classes from './modules/classes'
import perfil from './modules/perfil'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    habilidades,
    expertises,
    permissoes,
    usuario,
    usuarioSkills,
    classes,
    perfil
  }
})